export const en = {
    back: 'Back',
    details: 'Details',
    to_trips_list: 'To the application list',

};
